// extracted by mini-css-extract-plugin
export default {"nsp_cards":"NSPPaymentMethod_nsp_cards__T7UqJ","nsp_payment_method_title":"NSPPaymentMethod_nsp_payment_method_title__rFia+","nsp_method":"NSPPaymentMethod_nsp_method__pbiW7"};